import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FaSave, FaAngleLeft } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Auth } from 'aws-amplify';
import { useToasts } from 'react-toast-notifications';
import { Formik } from "formik";
import * as yup from "yup";
import { API } from 'aws-amplify';

import './Signup.scss';

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const Signup = (props) => {
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [contractorList, setContractorList] = useState([]);
    const { addToast } = useToasts();


	// Load contractors
	useEffect(()=>{
		const fetchContractors = async () => {

			const contractors = await API.get('company','/name', params)
			contractors.values.sort((a, b) => (a > b) ? 1 : -1)

			let list = []
			for (let i = 0; i < contractors.values.length; i++) 
				list.push(contractors.values[i])
				// list.push(<option key={contractors.values[i]} value={contractors.values[i]}>{contractors.values[i]}</option>)

			if (props.user.profile === 'SubAdmin') 
				list = list.filter(i => i === props.user.contractor)
	
			setContractorList(list);

		}
		if (props.user.profile)
			fetchContractors();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.user]);

	const handleSubmit = async (data) => {
		setBtnDisabled(false);
		try {

			await Auth.signUp({
				'username': data.email,
				'password': data.password,
				'attributes': {
					'name':data.name,
					'email':data.email,
					'custom:contractor': data.contractor,
					'custom:administrator': data.administrator,

				}
			});

			// Update user permissions
			await API.post('user_assets', '/', {
				body: {
					id: data.email,
					assets: [],
					settings: {
						format_date: 'DD-MM-YYYY',
						profile: 'General'
					}
				},
				headers: {
					'x-api-key': process.env.REACT_APP_API_KEY,
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					},
			})
			.then(response => {
				// console.log(response)
				// addToast('Asset Saved', { appearance: 'success' });
			}).catch(error => {
				// console.log(error)
				addToast('Error Saving User Permissions', { appearance: 'error' });
						});

			addToast('User Saved', { appearance: 'success' });
			props.history.push('/users/');

		} catch (e) {
			addToast(e.message, { appearance: 'error' });

		}
	};

	const schema = yup.object().shape({
		name: yup.string()
			.required('Required'),
		email: yup.string()
			.email('Invalid Email Address')
			.required("Required"),
		password: yup.string()
			.min(8, 'Password must be at least 8 characters')
			.matches(
				/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
				"Invalid Password"
			  )
			.required("Required"),
		confirmPassword: yup.string()
			.test('passwords-match', 'Password Confirmation must match', function(value) {
				if (!value) {
				return false;
				}
				return this.parent.password === value;
			})
			.required("Required"),
		contractor: yup.string()
			.required("Required"),
		administrator: yup.string()
			.required("Required"),
		});


	return (

		<Formik
		initialValues={{name:'',
					   	email:'',
						password:'',
						contractor:'',
						confirmPassword:'',
						administrator:'false',

					 }}
		validationSchema={schema}
		onSubmit={ (values, { setSubmitting }) => {
			setBtnDisabled(true);
			handleSubmit(values);
			setSubmitting(false);
		}}

		>
		{({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
		<div className="Signup">
			<form key="frm1" onSubmit={handleSubmit}>
			<div className="col-md-12">
				<div className="row header">
					<div>
						Add User
					</div>

					<div className="col-md-11 text-right">
						<Button variant="secondary" className="mr-1" onClick={()=>{props.history.goBack()}}>
							Back &nbsp;
							<FaAngleLeft />
						</Button>
						<Button variant="success" className="mr-1" type="submit" disabled={btnDisabled} >
							Save &nbsp;
							<FaSave />
						</Button>
					</div>
				</div>
            </div>

			<div className="col-md-12 bg-white border p-4 rounded">
			<div className="row">
				<div className="col-md-6">
				<div className="pb-3">
				<Form.Group controlId="name" className={touched.name && errors.name ? "has-error" : null}>
					<Form.Label>Name</Form.Label>
					<Form.Control autoFocus
					type="text"
					value={values.name}
					onChange={handleChange}
					/>
					{touched.name && errors.name ? <div className="error-message">{errors.name}</div> : null}
				</Form.Group>
				</div>
				<div className="pb-3">
				<Form.Group controlId="email" className={touched.email && errors.email ? "has-error" : null}>
					<Form.Label>Email</Form.Label>
					<Form.Control
					type="email"
					value={values.email}
					onChange={handleChange} />
					{touched.email && errors.email ? <div className="error-message">{errors.email}</div> : null}
				</Form.Group>
				</div>
				<div className="pb-3">
				<Form.Group controlId="contractor" className={touched.contractor && errors.contractor ? "has-error" : null} >
					<Form.Label>Group</Form.Label>
					<Form.Control as="select"
					value={values.contractor}
					onChange={handleChange}>
						<option key="cont1" value=""></option>
						{contractorList.map((item, i) => (
						<option key={item} value={item}>{item}</option>
						))}
					</Form.Control>
					{touched.contractor && errors.contractor ? <div className="error-message">{errors.contractor}</div> : null}
				</Form.Group>
				</div>
				<div className="pb-3">
				<Form.Group controlId="administrator" className={touched.administrator && errors.administrator ? "has-error" : null}>
					<Form.Label>Administrator</Form.Label>
					<Form.Control as="select"
					value={values.administrator}
					onChange={handleChange}
					disabled={props.user.administrator==='false'}>
						<option key="adm1" value="false">No</option>
						<option key="adm2" value="true">Yes</option>
					</Form.Control>
					{touched.administrator && errors.administrator ? <div className="error-message">{errors.administrator}</div> : null}
				</Form.Group>
				</div>
				</div>
				<div className="col-md-6">
				<div className="pb-3">
				<Form.Group controlId="password" className={touched.password && errors.password ? "has-error" : null}>
					<Form.Label>Password</Form.Label>
						<Form.Control
							value={values.password}
							onChange={handleChange}
							type="password" />
					{touched.password && errors.password ? <div className="error-message">{errors.password}</div> : null}
				</Form.Group>
				</div>
				<div className="pb-3">
				<Form.Group controlId="confirmPassword" className={touched.confirmPassword && errors.confirmPassword ? "has-error" : null}>
					<Form.Label>Confirm Password</Form.Label>
					<Form.Control
					value={values.confirmPassword}
					onChange={handleChange}
					type="password" />
					{touched.confirmPassword && errors.confirmPassword ? <div className="error-message">{errors.confirmPassword}</div> : null}
				</Form.Group>
				</div>

				<div className="p-4 text-dark small bg-light border rounded">
					<strong>Please provide a valid Password</strong>
					<ul>
						<li>at least 8 characters</li>
						<li>combination of upper and lower-case characters</li>
						<li>at least one number</li>
						<li>at least one special character <strong>#?!@$%^&amp;*-</strong></li>
					</ul>
				</div>

				</div>
				</div>

			</div>
			</form>
		</div>
		)}
		</Formik>
	);

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
    };
  };

export default connect(mapStateToProps)(Signup);
